import React from 'react';

import { MDBBtn, MDBIcon } from 'mdbreact';

import { caminhoDoRelatorio } from './caminho';

/**
 * Acesso ao relatório da abordagem em PDF.
 *
 * Um só componente para todas as telas que identificam uma abordagem, para que
 * a ação tenha sempre o mesmo nome e o mesmo ícone — antes ela existia só como
 * um link "IMPRIMIR" vermelho dentro de um modal.
 *
 * Abre em outra aba de propósito: as listagens têm filtro e paginação (a de
 * gestão passa de 17 mil páginas), e sair delas para ver o relatório fazia o
 * usuário perder a posição ao voltar.
 *
 * `variante`:
 *  - `icone` (padrão): ação de linha nas listagens
 *  - `botao`: telas e modais, onde as outras ações também são botões
 *
 * `compacto` esconde o rótulo no desktop. A regra é por LINHA, não por ação:
 * numa linha, ou todas as ações mostram o nome, ou nenhuma mostra. Em "minhas
 * abordagens" são quatro comandos numa coluna de 25% — com rótulo, "PDF" e
 * "Ver" caem para a linha de baixo; nas listas de gestão e participações são
 * dois, e lá o nome aparece.
 */
export default function RelatorioPdf({
  abordagemId,
  variante = 'icone',
  compacto = false,
  className = '',
}) {
  const caminho = caminhoDoRelatorio(abordagemId);
  if (!caminho) return null;

  const titulo = 'Relatório da abordagem em PDF';

  if (variante === 'botao') {
    return (
      <MDBBtn
        color="mdb-color"
        size="sm"
        className={className}
        title={titulo}
        onClick={() => window.open(caminho, '_blank', 'noopener')}
      >
        <MDBIcon far icon="file-pdf" className="mr-2" />
        Relatório PDF
      </MDBBtn>
    );
  }

  // rótulo sempre visível, e não só no `title`: o ícone de PDF fica ao lado do
  // clipe de anexos nas listagens — dois ícones de "arquivo" —, e `title` não
  // existe no celular, que é onde a tela é usada em campo.
  return (
    <a
      href={caminho}
      target="_blank"
      rel="noopener noreferrer"
      title={titulo}
      className={`d-flex align-items-center font-weight-bold ${className}`}
      style={{ cursor: 'pointer', color: '#59698d' }}
    >
      <MDBIcon far icon="file-pdf" size="lg" />
      {/* no desktop a coluna de ações é estreita e "Relatório PDF" quebra em
          duas linhas; no celular cada ação tem a linha inteira e cabe o nome */}
      {!compacto && (
        <span className="ml-2 d-none d-md-inline text-nowrap">PDF</span>
      )}
      <span className="ml-2 d-md-none">Relatório PDF</span>
    </a>
  );
}
